import {hitGoogleTagManager} from "./hit_google_tag_manager";

export const gtmEventPropertyListPrice = (position: number) => {
    const gtmData = {
        event: "property_list_price",
        event_action: "click",
        event_label: `${position}`
    };

    hitGoogleTagManager(gtmData);
};
import {hitGoogleTagManager} from "./hit_google_tag_manager";

export const gtmEventPropertyListPrice = (position: number) => {
    const gtmData = {
        event: "property_list_price",
        event_action: "click",
        event_label: `${position}`
    };

    hitGoogleTagManager(gtmData);
};
